export const fetchWithTimeout = async (
  input: string,
  init: RequestInit,
  timeout: number,
) => {
  const response = await withTimeout(
    async ({ signal }) =>
      await fetch(input, {
        ...init,
        signal,
      }),
    {
      timeout,
      signal: true,
    },
  )
  return response
}

const withTimeout = (
  function_: ({
    signal,
  }: {
    signal?: AbortController['signal']
  }) => Promise<Response>,
  {
    errorInstance = new Error('timed out'),
    timeout,
    signal,
  }: {
    // The error instance to throw when the timeout is reached.
    errorInstance?: Error
    // The timeout (in ms).
    timeout: number
    // Whether or not the timeout should use an abort signal.
    signal?: boolean
  },
): Promise<Response> =>
  new Promise((resolve, reject) => {
    let mut_timeoutId: ReturnType<typeof setTimeout> | undefined
    try {
      const controller = new AbortController()
      if (timeout > 0) {
        mut_timeoutId = setTimeout(() => {
          if (signal === undefined) {
            reject(errorInstance)
          } else {
            controller.abort()
          }
        }, timeout)
      }
      function_({ signal: controller.signal })
        .then((value) => {
          resolve(value)
        })
        .catch((error) => {
          reject(error)
        })
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError')
        reject(errorInstance)
      reject(error)
    } finally {
      clearTimeout(mut_timeoutId)
    }
  })
